import * as React from 'react'
import {FC, Fragment} from 'react'
import {observer} from 'mobx-react'
import {useStores} from '../../lib/MobXProvider'
import {WidgetApi} from '../../lib/WidgetApi'
import {getDynamicComponentByType} from '../../lib/DynamicComponents'
import {SlotComponentConfig} from '../../lib/WidgetConfig'

///////////////////////////////////////////////////////////////////////////////

export type DynamicComponentProps = {
  slots: SlotComponentConfig[]
  [key: string]: any
}

///////////////////////////////////////////////////////////////////////////////

export const DynamicComponent: FC<DynamicComponentProps> = observer((props) => {
  const {api} = useStores<{api: WidgetApi}>()
  let {slots, ...rest} = props
  slots = slots || []

  const children = slots.map((slot, key) => {
    if (!api.compiler.checkCondition({if: slot.if})) {
      return null
    }

    // react requires key to be set
    ;(slot as any).key = key

    const componentFactory = getDynamicComponentByType(slot.component)

    return componentFactory({...slot, ...rest, key: key})
  })

  return <Fragment>{children}</Fragment>
})
